'use client';

import React from 'react';
import { TasticProps } from '../types';
import BrandPromise from 'components/commercetools-ui/organisms/brand-promise';
import { BrandPromiseProps } from 'components/commercetools-ui/organisms/brand-promise/types';

const BrandPromiseTastic = ({ data }: TasticProps<BrandPromiseProps>) => {
  return <BrandPromise {...data} />;
};

export default BrandPromiseTastic;
